import {Component, ElementRef, OnInit} from '@angular/core';
import {HttpService} from '../shared/services/http.service';
import {Actions, ofType} from '@ngrx/effects';
import {HideInteractionCardAction, ShowInteractionCardAction} from '../shared/stores/root-store/actions/interaction.action';

@Component({
    selector: 'eocm-video-interaction',
    templateUrl: './interaction.component.html',
    styleUrls: ['./interaction.component.scss']
})
export class InteractionComponent implements OnInit {
    public htmlContent: string;

    constructor(private httpService: HttpService,
        private actions$: Actions,
        private ref: ElementRef) {
        this.actions$.pipe(ofType(ShowInteractionCardAction)).subscribe(({id}) => {
            this.showInteractionCard(id);
        });

        this.actions$.pipe(ofType(HideInteractionCardAction)).subscribe(() => {
            this.hideInteractionCard();
        });
    }

    ngOnInit() {
        const interactionTemplate = (window as any).interactionTemplate;

        if (!interactionTemplate) {
            return;
        }

        try {
            this.httpService.getInteractionHtml((window as any).interactionTemplate).subscribe(
                response => {
                    this.htmlContent = response;
                },
                error => {
                    console.error(error.message);
                    this.htmlContent = '';
                }
            );
        } catch (e) {
            this.htmlContent = '';
        }

    }

    private showInteractionCard(id: string) {
        try {
            const container = this.ref.nativeElement.querySelector('#interactions');

            this.ref.nativeElement.querySelectorAll('.interaction-card').forEach(card => {
                if (card.attributes['data-card'].value === id) {
                    card.style.display = 'block';

                    return;
                }

                card.style.display = 'none';
            });

            container.style.display = 'block';
        } catch (e) {}
    }

    private hideInteractionCard() {
        try {
            const container = this.ref.nativeElement.querySelector('#interactions');

            container.style.display = 'none';

            this.ref.nativeElement.querySelectorAll('.interaction-card').forEach(card => {
                card.style.display = 'none';
            });

        } catch (e) {}
    }
}
